import { render, staticRenderFns } from "./InvestmentAnalytics.vue?vue&type=template&id=a61cda84&scoped=true&"
import script from "./InvestmentAnalytics.vue?vue&type=script&lang=js&"
export * from "./InvestmentAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentAnalytics.vue?vue&type=style&index=0&id=a61cda84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61cda84",
  null
  
)

export default component.exports